export const FEED_COINS_TEMPORARY = "FEED_COINS_TEMPORARY";
export const FEED_VIP_TEMPORARY = "FEED_VIP_TEMPORARY";
export const DELIVERED_OFFER_TEMPORARY = "DELIVERED_OFFER_TEMPORARY";
export const SPLASH_DOUBLE_COINS_TEMPORARY = "SPLASH_DOUBLE_COINS_TEMPORARY";
export const COIN_STORE_DOUBLE_COINS_TEMPORARY =
  "COIN_STORE_DOUBLE_COINS_TEMPORARY";
class AnalyticsHelper {
  public temporaryMap: any;

  constructor() {
    this.temporaryMap = new Map();
  }

  public getKey(key: string) {
    if (this.temporaryMap.has(key)) {
      console.log("this.temporaryMap:", this.temporaryMap);
      return this.temporaryMap.get(key);
    } else {
      return null;
    }
  }

  public setKey(key: string, value: any) {
    this.temporaryMap.set(key, value);
    console.log("afterset:", this.temporaryMap);
  }

  public clearKey(key: string) {
    this.temporaryMap.delete(key);
    console.log("afterClear:", this.temporaryMap);
  }
}

export const AnalyticsHelperEl = new AnalyticsHelper();
